import React from 'react';
import { Check, X } from 'lucide-react';

export interface CaptionTrack {
  id: string;
  label: string;
  sub?: string;
  /** Browser language tag, e.g. 'en', 'sv', 'ja'. */
  lang?: string;
}

interface OdenCaptionsMenuProps {
  tracks: CaptionTrack[];
  current: string | null;
  onSelect: (trackId: string | null) => void;
  onClose: () => void;
}

const OdenCaptionsMenu: React.FC<OdenCaptionsMenuProps> = ({ tracks, current, onSelect, onClose }) => {
  return (
    <div className="oden-menu" style={{ width: 280 }} role="menu" aria-label="Subtitles">
      <div className="oden-menu-hd">
        <span style={{ flex: 1 }}>Subtitles</span>
        <button type="button" className="oden-menu-x" onClick={onClose} aria-label="Close">
          <span style={{ width: 14, height: 14, display: 'inline-flex' }}>
            <X size={14} />
          </span>
        </button>
      </div>

      <button
        type="button"
        role="menuitemradio"
        aria-checked={current === null}
        className="oden-menu-row"
        data-on={current === null ? '1' : '0'}
        onClick={() => onSelect(null)}
      >
        <span style={{ width: 16, height: 16, display: 'inline-flex', opacity: current === null ? 1 : 0 }}>
          <Check size={16} />
        </span>
        <span style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
          <span>Off</span>
        </span>
      </button>

      {tracks.map((t) => {
        const active = t.id === current;
        return (
          <button
            key={t.id}
            type="button"
            role="menuitemradio"
            aria-checked={active}
            className="oden-menu-row"
            data-on={active ? '1' : '0'}
            onClick={() => onSelect(t.id)}
          >
            <span style={{ width: 16, height: 16, display: 'inline-flex', opacity: active ? 1 : 0 }}>
              <Check size={16} />
            </span>
            <span style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
              <span>{t.label}</span>
              {t.sub && <span style={{ fontSize: 10.5, opacity: 0.55 }}>{t.sub}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default OdenCaptionsMenu;
